import { useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Space, Select, Modal, Form, Row, Col, TreeSelect } from 'antd'
import { SearchOutlined, RedoOutlined, DeleteOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import { SelectStores } from "../../component/common/Selects"
import { PutOnOffsButtonYZ } from "../../component/common/Buttons"
import getPermission from '../../js/permission'
import { pointMoreThanTwo } from "../../js/number"
import _ from 'lodash'

const { Option } = Select
const { Column } = Table

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 19 }
}

type fetchParams = {
    store_id: string | undefined
    item_name: string | undefined
    item_status: number | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

type project = {
    id: string
    item_name: string
}

const initForm = {
    item_id: undefined,
    store_id: undefined,
    item_old_price: undefined,
    item_latest_price: undefined,
    order_level: undefined
}

interface reciveRow {
    id?: undefined | string // 配置折扣标识，若新增的则为空
    discount: undefined | number, // 折扣
    department_id: undefined | string, // 组织标识
    employee_id: undefined | string, // 员工标识
    employee_name?: undefined | string // 员工名称
}

interface rewardsRow {
    id?: undefined | string // 配置奖励标识，若新增的则为空
    member_grade_id: undefined | string, // 会员等级标识
    recommend_type: undefined | string, // 推荐类型
    rewards_value: undefined | number, // 奖励价值
    rewards_points: undefined | number, // 奖励积分
    rewards_days: undefined | number // 奖励天数
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        item_name: undefined,
        item_status: undefined
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    // 列表数据
    const [data, setData] = useState<any>([])

    const [form] = Form.useForm()
    const [addVisible, setAddVisible] = useState<boolean>(false)

    const [activeID, setActiveID] = useState<string | undefined>(undefined)
    const [selectNameData, setSelectNameData] = useState<project[]>([])

    const [depData, setDepData] = useState<any[]>([])
    const [empData, setEmpData] = useState<any[]>([])

    const [gradeData, setGradeData] = useState<any[]>([])

    let reciveMoneyRow: reciveRow = {
        discount: undefined,
        department_id: undefined,
        employee_id: undefined
    }

    let configRewardsRow: rewardsRow = {
        member_grade_id: undefined,
        recommend_type: undefined,
        rewards_value: undefined,
        rewards_points: undefined,
        rewards_days: undefined
    }

    const [reciveMoneyData, setReciveMoneyData] = useState<reciveRow[]>([{
        discount: undefined,
        department_id: undefined,
        employee_id: undefined
    }])

    const [configRewardsData, setConfigRewardsData] = useState<rewardsRow[]>([{
        member_grade_id: undefined,
        recommend_type: undefined,
        rewards_value: undefined,
        rewards_points: undefined,
        rewards_days: undefined
    }])

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })

        // 查询项目
        baseAxiosNoInfo('/global/item_list', {
            params: { item_type: 3 }

        }).then((res: any) => {
            res && setSelectNameData(res)
        })

        // 查询会员等级
        baseAxiosNoInfo.get('/global/member_grade_list').then((response: any) => {
            if (response) setGradeData(response)
        })
    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleChange2 = (index: number, attr: string, value: any) => {
        let reciveD: any = _.cloneDeep(reciveMoneyData)
        reciveD[index][attr] = value

        setReciveMoneyData(reciveD)
    }

    const handleChange3 = (index: number, attr: string, value: any) => {
        let rewardsD: any = _.cloneDeep(configRewardsData)
        rewardsD[index][attr] = value

        setConfigRewardsData(rewardsD)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        let iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        axiosTable.get('/yuezi_center/put_on_off/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const addMoreRow = () => {
        setReciveMoneyData([...reciveMoneyData, reciveMoneyRow])
    }

    const deleteRow = (index: number) => {
        if (reciveMoneyData.length > 1) {
            let reciveD = _.cloneDeep(reciveMoneyData)
            reciveD.splice(index, 1)

            setReciveMoneyData(reciveD)
        }
    }

    const addRewardsRow = () => {
        setConfigRewardsData([...configRewardsData, configRewardsRow])
    }

    const deleteRewardsRow = (index: number) => {
        if (configRewardsData.length > 1) {
            let rewardsD = _.cloneDeep(configRewardsData)
            rewardsD.splice(index, 1)

            setConfigRewardsData(rewardsD)
        }
    }

    const priceVaild = (which: any, value: any) => {
        if (!value) return Promise.reject(which.field === "item_old_price" ? '原价必填' : '优惠价必填')

        if (value <= 0 || pointMoreThanTwo(value)) return Promise.reject('该价格必须大于0，且如果是小数不得多于2位小数')

        if (Number(form.getFieldValue('item_old_price')) < Number(form.getFieldValue('item_latest_price'))) {
            return Promise.reject('优惠价必须小于原价')
        }

        return Promise.resolve()
    }

    const orderLevelVaild = (_: any, value: any) => {
        if (!value) return Promise.reject('填写正整数排序值')

        let numStr = value.toString()
        if (isNaN(Number(value)) || Number(value) <= 0 || numStr.includes('.')) return Promise.reject('必须是大于0的整数')

        return Promise.resolve()
    }

    const recursionChildren = (children: any[]) => {
        let childArr: any = []

        children.forEach((el: any) => {
            childArr.push({
                title: el.department_name,
                value: el.department_id,
                key: el.department_id,
                children: el.children && recursionChildren(el.children)
            })
        })

        return childArr
    }

    const onFinish = (values: any) => {
        let url = activeID ? '/yuezi_center/put_on_off/update' : '/yuezi_center/put_on_off/add'

        if (activeID) {
            values.id = activeID
        }

        values.store_id = [values.store_id]
        values.item_old_price = +values.item_old_price
        values.item_latest_price = +values.item_latest_price
        values.review_discount_list = reciveMoneyData
        values.rewards_list = configRewardsData

        baseAxiosComplete.post(url, values).then(res => {
            if (res.status === 0) {
                setAddVisible(false)
                form.setFieldsValue(initForm)

                resetForm()
            }
        })
    }

    let ItemNameOptions = selectNameData.map((el: any) => (<Option value={el.id} key={el.id}>{el.item_name}</Option>))

    return (<div className="common-page">
        {/* 月子中心 -> 月子项目管理 -> 门店上架管理 */}
        <BreadCrumb position={['月子中心', '门店上架管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores onChange={(value: string) => { handleChange(value, 'store_id') }} value={fetchOtherParams.store_id} />
                </div>
                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="项目名称" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'item_name') }} value={fetchOtherParams.item_name} />
                <Select style={{ marginRight: 8, marginBottom: 12, width: 120 }} onChange={(value: number) => { handleChange(value, 'item_status') }} placeholder="状态" value={fetchOtherParams.item_status} >
                    <Option value="1">上架中</Option>
                    <Option value="2">已下架</Option>
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('添加') && <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" onClick={() => {
                    form.setFieldsValue(initForm)
                    setAddVisible(true)

                    setActiveID(undefined)
                    setReciveMoneyData([reciveMoneyRow])
                    setConfigRewardsData([configRewardsRow])
                }}>添加</Button>}
            </div>
        </div>

        <div className="common-main">
            <Table dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination} onChange={handleTableChange}>
                <Column title="门店名称" dataIndex="store_name" key="store_name" />
                <Column title="项目名称" dataIndex="item_name" key="item_name" />
                <Column title="项目原价" dataIndex="item_old_price" key="item_old_price" />
                <Column title="项目优惠价" dataIndex="item_latest_price" key="item_latest_price" />
                <Column title="上架时间" dataIndex="on_time" key="on_time" />
                <Column title="下架时间" dataIndex="off_time" key="off_time" />
                <Column title="状态" dataIndex="item_status" key="item_status" render={(v: any) => v === 1 ? '上架' : '下架'} />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => (
                        <Space size="middle">
                            {permission.includes('编辑') && <Button type="primary" size="small" onClick={() => {
                                baseAxiosNoInfo('/yuezi_center/put_on_off/detail', { params: { id: record.id } }).then((res: any) => {
                                    if (res) {
                                        form.setFieldsValue({
                                            item_id: res.item_id,
                                            store_id: [res.store_id],
                                            item_old_price: res.item_old_price,
                                            item_latest_price: res.item_latest_price,
                                            order_level: res.order_level
                                        })

                                        setActiveID(record.id)
                                        setAddVisible(true)

                                        setConfigRewardsData(res.rewards_list)

                                        // 查询该门店的部门
                                        baseAxiosNoInfo('/global/department_list_by_store', {
                                            params: {
                                                store_id: res.store_id
                                            }

                                        }).then((res2: any) => {
                                            res2 && setDepData(res2)

                                            if (res.review_discount_list.length > 0) {
                                                setReciveMoneyData(res.review_discount_list)
                                            }
                                        })
                                    }
                                })
                            }}>编辑</Button>}

                            {record.item_status === 1 && <PutOnOffsButtonYZ id={record.id} url="/yuezi_center/put_on_off/on_off" type="off" cb={resetForm} />}
                            {record.item_status === 2 && <PutOnOffsButtonYZ id={record.id} url="/yuezi_center/put_on_off/on_off" type="on" cb={resetForm} />}
                        </Space>
                    )}
                />
            </Table>
        </div>

        <Modal title={activeID ? "编辑上架" : "新增上架"} visible={addVisible} onCancel={() => { setAddVisible(false) }} footer={false} width="850px">
            <Form form={form} name="validate_other" {...formItemLayout} onFinish={onFinish} >
                <Form.Item label="选择门店" name="store_id" rules={[{ required: true, message: '必须选择门店' }]} >
                    <SelectStores disabled={!!activeID} onChange={((v: any) => {
                        // 查询该门店的部门
                        baseAxiosNoInfo('/global/department_list_by_store', {
                            params: {
                                store_id: v
                            }

                        }).then((res2: any) => {
                            res2 && setDepData(res2)
                        })
                    })} />
                </Form.Item>

                <Form.Item label="选择项目" name="item_id" rules={[{ required: true, message: '必须选择项目' }]} >
                    <Select virtual={false} disabled={!!activeID} >
                        {ItemNameOptions}
                    </Select>
                </Form.Item>

                <Form.Item required label="设置原价" name="item_old_price" rules={[{ validator: priceVaild }]} >
                    <Input type="number" placeholder="设置原价" />
                </Form.Item>

                <Form.Item required label="设置优惠价" name="item_latest_price" rules={[{ validator: priceVaild }]}  >
                    <Input type="number" placeholder="设置优惠价" />
                </Form.Item>

                <Form.Item required label="设置折扣" >
                    <Row style={{ marginBottom: 16 }} gutter={8} >
                        <Col span={9}>部门</Col>
                        <Col span={6}>审批人</Col>
                        <Col span={6}>折扣率</Col>
                    </Row>

                    {reciveMoneyData.map((el, index: number) => <Row gutter={8} style={{ marginBottom: 8, userSelect: 'none' }}>
                        <Col span={9}>
                            <TreeSelect style={{ width: '100%' }} value={el.department_id} virtual={true} treeData={recursionChildren(depData)} placeholder="组织" onChange={(v: any) => {
                                // 查询该部门下的员工
                                baseAxiosNoInfo('/global/employee_list_by_position', {
                                    params: {
                                        department_id: v
                                    }

                                }).then((res: any) => {
                                    res && setEmpData(res)
                                })

                                handleChange2(index, 'department_id', v)
                            }} />
                        </Col>

                        <Col span={6}>
                            <Select value={el.employee_name} style={{ width: '100%' }} onChange={(v: string) => {
                                handleChange2(index, 'employee_id', v)
                            }}>
                                {empData.map(el => <Option key={el.employee_id} value={el.employee_id}>{el.user_name}</Option>)}
                            </Select>

                            {/* {activeID && <span>{el.employee_name}</span>} */}
                        </Col>

                        <Col span={6}><Input value={el.discount} onChange={(v) => {
                            handleChange2(index, 'discount', v.target.value)
                        }} /></Col>

                        <Col span={3} onClick={() => { deleteRow(index) }}><DeleteOutlined style={{ marginTop: 10, color: 'red' }} /></Col>
                    </Row>)}

                    <Button onClick={addMoreRow} style={{ marginTop: 16 }} size="small" type="primary">添加折扣</Button>
                </Form.Item>

                <Form.Item label="设置奖励" >
                    <Row style={{ marginBottom: 20 }} gutter={8} >
                        <Col span={5}>会员等级</Col>
                        <Col span={4}>推荐类型</Col>
                        <Col span={4}>奖励价值</Col>
                        <Col span={4}>奖励积分</Col>
                        <Col span={4}>奖励天数</Col>
                    </Row>

                    {configRewardsData.map((el, index: number) => <Row gutter={8} style={{ marginBottom: 5, marginTop: 10, userSelect: 'none' }}>
                        <Col span={5}>
                            <Select value={el.member_grade_id} style={{ width: '100%' }} onChange={(v: string) => {
                                handleChange3(index, 'member_grade_id', v)
                            }}>
                                {gradeData.map(el => <Option key={el.id} value={el.id}>{el.grade_name}</Option>)}
                            </Select>
                        </Col>

                        <Col span={4}>
                            <Select value={el.recommend_type == null ? '' : el.recommend_type == '1' ? "推荐人" : "被推荐人"} style={{ width: '100%' }} onChange={(v: string) => {
                                handleChange3(index, 'recommend_type', v)
                            }}>
                                <Option value='1' >推荐人</Option>
                                <Option value='2' >被推荐人</Option>
                            </Select>
                        </Col>

                        <Col span={4}><Input value={el.rewards_value} onChange={(v) => {
                            handleChange3(index, 'rewards_value', v.target.value)
                        }} /></Col>

                        <Col span={4}><Input value={el.rewards_points} onChange={(v) => {
                            handleChange3(index, 'rewards_points', v.target.value)
                        }} /></Col>

                        <Col span={4}><Input value={el.rewards_days} onChange={(v) => {
                            handleChange3(index, 'rewards_days', v.target.value)
                        }} /></Col>

                        <Col span={3} onClick={() => { deleteRewardsRow(index) }}><DeleteOutlined style={{ marginTop: 10, color: 'red' }} /></Col>
                    </Row>)}

                    <Button onClick={addRewardsRow} style={{ marginTop: 16 }} size="small" type="primary">添加奖励</Button>
                </Form.Item>

                <Form.Item label="排序" name="order_level" rules={[{ validator: orderLevelVaild }]} >
                    <Input type="number" placeholder="不填则默认以上架时间排序" style={{ width: '50%' }} />
                </Form.Item>

                <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>
    </div>)
}